"use client"

import type { FC, SVGProps } from "react"
import * as React from "react"
import { IconChevronDownOutline18 as ChevronDown } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/browser"

type LucideIcon = FC<SVGProps<SVGSVGElement>>

// A button styled to match the Select trigger, for use as the trigger of a
// DropdownMenu/Popover when the control is a menu (multi-select, actions)
// rather than a single-value Select. Keeps those controls visually consistent
// with real Selects on the same settings row.
export const SelectTrigger = React.memo(
	React.forwardRef<
		HTMLButtonElement,
		React.ComponentPropsWithoutRef<"button"> & {
			Icon?: LucideIcon
			iconClassName?: string
			chevronClassName?: string
		}
	>(
		(
			{ className, children, Icon, iconClassName, chevronClassName, ...props },
			ref,
		) => (
			<button
				ref={ref}
				type="button"
				className={cn(
					"flex h-8 w-full items-center gap-2 rounded-md bg-white pl-3 pr-2 text-sm shadow-sm ring-1 ring-inset ring-black/15 placeholder:text-gray-400 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 dark:bg-gray-900 dark:text-gray-50 dark:ring-white/15",
					className,
				)}
				{...props}
			>
				{Icon && <Icon className={cn("h-4 w-4", iconClassName)} />}
				<span className="flex-1 truncate text-left">{children}</span>
				<ChevronDown
					className={cn("h-3 w-3 opacity-50", chevronClassName)}
					strokeWidth={1.75}
				/>
			</button>
		),
	),
)
